export default "__VITE_ASSET__gYG6A51h__"